<div
  class="badge"
  [ngClass]="{
    'badge--3': config.type === BadgeTypes.priority,
    'badge--flat': config.type === BadgeTypes.flat,
    'badge--large': config.size === BadgeSizes.large,
    'badge--small': config.size === BadgeSizes.small,
  }"
>
  @if (config.size === BadgeSizes.small) {
    <p class="t-data t-bold" data-test-id="badgeSmallHeader">
      {{ config.value }}
    </p>
  } @else {
    <h4 class="t-bold" data-test-id="badgeDefaultHeader">
      {{ config.value }}
    </h4>
  }

  @if (config.link) {
    <p
      class="t-data t-link"
      data-test-id="badgeLabelWithLink"
      (click)="linkClicked.emit($event)"
    >
      {{ config.label }}
    </p>
  } @else {
    <p class="t-data t-alt" data-test-id="badgeDefaultLabel">
      {{ config.label }}
    </p>
  }
</div>
